import { createContext } from 'react';

import { IMenuContextState } from './MenuContextState';

export const MenuContext = createContext({} as IMenuContextState);
